export default "__VITE_ASSET__BFFqHZVw__"